export const base_url =
  "https://sp3d6vfm3lki44hr3pzv4qq7da0zhguh.lambda-url.eu-west-2.on.aws";
export const login = "/auth/login";
export const signup = "/auth/signup";
export const createBusiness = "/accounter/business/create";
export const getUserBusiness = "/accounter/business/getUserBusiness";
export const createNewInvoice = "/accounter/business/sales/create";
export const category = "/accounter/business/expenses/categories";
export const createLogExpense = "/accounter/business/expenses/create";
export const recordMileage = "/accounter/business/mileage/create";
export const createBankStatement = "/accounter/business/bank/statement/create";
export const getExpenseList = "accounter/business/expenses/get";
export const getSalesList = "accounter/business/sales/get";
export const getMileageList = "accounter/business/mileage/get";
export const getBankStatementsList = "accounter/business/bank/statement/get";
export const takeImageUploadExpenseUrl = "/accounter/business/document/upload";
export const createEvent = "/events/create";
export const inviteSend = "/invitations";
export const inviteAccept = "/invitations/accept";
export const inviteDecline = "/invitations/decline";
export const createRoles = "/roles";
export const getModules = "/modules";
export const getPermissions = "/permissions";
export const getDocumentsList = "/accounter/business/documents/list";
export const downloadDocuments = "/tasks/v2/media";
// export const takeImageUploadSalesUrl = 'accounter/business/uploadBill';

// Company Financial Analytics
export const getAnalyticsYears = "/company-analytics"; // will append :businessId/years
export const getAnalyticsSummary = "/company-analytics"; // will append :businessId/summary
export const getRevenueBreakdown = "/company-analytics"; // will append :businessId/revenue-breakdown
export const getExpenseBreakdown = "/company-analytics"; // will append :businessId/expense-breakdown
export const getCashPosition = "/company-analytics"; // will append :businessId/cash-position
export const getVatDetails = "/company-analytics"; // will append :businessId/vat
export const getKeyMetrics = "/company-analytics"; // will append :businessId/key-metrics

// Personal Tax APIs
export const getPersonalTaxYears = "/accounter/personal-tax/years"; // will append /:businessId
export const getPersonalTaxSummary = "/accounter/personal-tax"; // will append /:businessId/:taxYearId/summary
export const getPersonalTaxTransactions = "/accounter/personal-tax"; // will append /:businessId/:taxYearId/transactions
export const createPersonalTaxAdjustment = "/accounter/personal-tax"; // will append /:businessId/:taxYearId/adjustments
export const getPersonalTaxChecklist = "/accounter/personal-tax"; // will append /:businessId/:taxYearId/checklist
export const getBusinessEmployees = "/accounter/business/employee"; // will append /:businessId
